const divPhotoUp = {
  load: 'Carregando...'
};

export default divPhotoUp;
